import 'sbf-design-system-component/broadcast_messages/broadcast_message';

// loads the map, gets all events, and starts the browser's geolocation process
window.initMap = function initMap () {
  (new Image()).src = '/fa/min/php_legacy/register/infobox-bottom.png';
  (new Image()).src = '/fa/min/php_legacy/icons/x.png';
  (new Image()).src = '/fa/min/php_legacy/register/map-marker.png';
  (new Image()).src = 'https://maps.google.com/mapfiles/marker.png';
  (new Image()).src = '/fa/min/php_legacy/register/infobox-bottom.png';

  sbf.choose_event.geocoder = new google.maps.Geocoder();

  if (sbf.choose_event.check_window_size() == 'large') {
    // set the map to the appropriate height...default is 800px...minimum is 600px
    const height = $(window).height() - 300;
    if (height < 600) {
      $('#event-map-container').height(600);
    } else {
      $('#event-map-container').height(height);
    }

    // set the event-list-container height appropriately as well
    // would rather do this in CSS but it's a complicated setup
    // and we want to be able to scroll, so set height is necessary
    const mapHeight = $('#event-map-container').height();
    $('#event-list-container').height(mapHeight - 180);
    $('#event-list').height(mapHeight - 20);
  }

  if ($('#event-map').css('visibility') != 'hidden') {
    // only load the map if we are in a view that will show it immediately
    sbf.choose_event.load_map();
  }

  sbf.choose_event.process_get_all_events(
    sbf.choose_event.load_all_events, // success callback
    function () { // error callback
      sbf.choose_event.show_search_error('Sorry, there was an error loading our events. ' +
                    'Please refresh the page, and let us know if you keep getting this error.');
    });

  sbf.choose_event.process_geolocate();

  // bind knockout for info windows and search results
  window.viewModel = new EventSearchResults();
  ko.applyBindings(window.viewModel);
  $('#search-results').show();

  // bind form submits
  $('#event-search-form').bind('submit', function (submit) {
    submit.preventDefault();

    const searchText = $.trim($('#event-search-input').val());
    if (searchText == '' || $('#event-list').hasClass('loading')) {
      return false;
    }

    // reset things
    sbf.choose_event.searches_run = 0;
    sbf.choose_event.saved_search_text = null;
    sbf.choose_event.saved_search_geo = null;
    window.viewModel.resetResults();

    // run the search
    sbf.choose_event.process_one_box_search(searchText,
      sbf.choose_event.load_search_results,
      function () {
        sbf.choose_event.show_search_error('Sorry, there was an error loading your search results. Please try again.');
      }
    );
  });

  $('#event-search-button').bind('click', function (click) {
    click.preventDefault();
    $('#event-search-form').trigger('submit');
  });

  // bind the more-results link
  $('#more-results').on('click', function (click) {
    click.preventDefault();

    if (sbf.choose_event.saved_search_text != null) {
      sbf.choose_event.process_one_box_search(sbf.choose_event.saved_search_text,
        sbf.choose_event.load_search_results,
        function () {
          sbf.choose_event.show_search_error('Sorry, there was an error loading your search results. Please try again.');
        }
      );
    } else if (sbf.choose_event.saved_search_geo != null) {
      // run a geolocate search on that location
      const geo = sbf.choose_event.saved_search_geo;
      sbf.choose_event.process_geolocation_search(geo.lat, geo.lon,
        sbf.choose_event.load_search_results,
        function () {
          sbf.choose_event.show_search_error('Sorry, there was an error loading your search results. Please try again.');
        }
      );
    }
  });

  // bind the events nearby link
  $('#events-nearby').click(function (click) {
    click.preventDefault();
    sbf.form_errors.close_all_errors();
    if (sbf.choose_event.saved_background_geo_results != null) {
      sbf.choose_event.load_search_results(sbf.choose_event.saved_background_geo_results);
    }
  });

  // bind actions of clicking on event name
  $('#event-list-container').delegate('.name', 'click', function (click) {
    click.preventDefault();

    if (sbf.choose_event.check_window_size() == 'large') {
      // open the info window
      const i = $(this).attr('dataevent');
      // If a window is already opened, close it
      if (sbf.choose_event.open_info_window) {
        sbf.choose_event.open_info_window.close();
      }

      window.viewModel.activeInfoWindow(window.viewModel.infoWindows()[i]);
      const info_window = new InfoBox({
        content: $('#event-info')[0],
        maxWidth: 360,
        boxClass: 'event-info',
        alignBottom: true,
        infoBoxClearance: new google.maps.Size(5, 5),
        pixelOffset: new google.maps.Size(-180, -35),
        closeBoxURL: '/fa/min/php_legacy/icons/x.png'
      });

      info_window.open(sbf.choose_event.map, sbf.choose_event.events[i].marker);

      sbf.choose_event.open_info_window = info_window;
      if (sbf.choose_event.check_window_size() == 'large') {
        sbf.choose_event.pan_to_point(sbf.choose_event.events[i].marker.getPosition().lat(), sbf.choose_event.events[i].marker.getPosition().lng());
      }

      // Workaround for showing the private event label and tooltip.
      window.setTimeout(function () {
        $('#event-map a.private-event').each(function () {
          const $card = $(this).closest('.entity-card');
          $('<br/>').insertAfter(
            $card.find('.private-event-label')
              .html('PRIVATE')
              .css('display', 'inline-block')
              .next('span.private-event-tooltip-button')
              .css('display', 'inline-block')
          );
          privateEventTooltipButtonAssignEventHandlers($card.find('.private-event-tooltip-button'));
          // Fix broken button link.
          const $a = $card.find('.actions').find('a[href="#"]');
          let info = $a.attr('dataevent');
          if (info && typeof info !== 'undefined') {
            info = info.split(/\-/);
            if (info.length === 2) {
              $a.attr('href', `/register/shavee/${info[0]}/${info[1]}`).unbind('click').bind('click', function (click) {
                click.preventDefault();
                window.viewModel.joinPrivateEventClick(this);
                return false;
              });
            }
          }
        });
      }, 100);
    }
  });

  // bind pane flips on small and medium size
  $('#event-show-map-link').on('click', function (click) {
    click.preventDefault();
    sbf.choose_event.flip_pane('eventmap');
  });

  $('#event-show-list-link').on('click', function (click) {
    click.preventDefault();
    sbf.choose_event.flip_pane('eventlist');
  });

  // bind no button on private-event-check-overlay
  $('#private-event-overlay-cancel').on('click', function (click) {
    click.preventDefault();
    sbf.overlay.hide();
  });

  // bind window resize to load map if not loaded
  $(window).resize(function (resize) {
    if (sbf.choose_event.map == null && sbf.choose_event.check_window_size() == 'large') {
      sbf.choose_event.load_map();
    }
  });
}

$(document).ready(function () {
  function getKeys (object) {
    const keys = [];
    for (const i in object) {
      if (object.hasOwnProperty(i)) {
        keys.push(i);
      }
    }
    return keys;
  }

  // Yes. I am adding UA sniffing. It's nasty. DJ assures me that it's temporary.
  const activeMapsListeners = [];
  const isiOS7 = navigator.userAgent.match(/(iPad|iPhone|iPod touch)/i);

  if (isiOS7) {
    $('body').addClass('ios7');
  }

  // set window.sbf if not set by another file
  if (!window.sbf) {
    window.sbf = {};
  }

  // knockout stuff
  // meta-data in cards
  function EventMetaData (icon, text, listclass) {
    const self = this;
    self.icon = icon;
    self.text = text;

    if (listclass == null) {
      self.listitemclass = '';
    } else {
      self.listitemclass = listclass;
    }

    this.iconclass = ko.computed(function () {
      // here we choose the class for the icon
      switch (self.icon) {
      case 'date':
        return 'icon-calendar';
      case 'location':
        return 'icon-pushpin';
      case 'venue':
        return 'icon-flag';
      case 'email':
        return 'icon-envelope';
      case 'address':
        return 'icon-home';
      case 'teamname':
        return 'icon-trophy';
      case 'facebook':
        return 'icon-facebook circle';
      case 'time':
        return 'icon-time';
      case 'none':
        return 'none';
      default:
        return 'icon-caret-right';
      }
    });
  }

  // just needs the html for the action
  function EventAction (html) {
    const self = this;
    self.html = html;
  }

  function getRearrangedFundIDLink (event) {
    // this will create a link by striping extra params and adding them to the end of new link, for example:
    // xxxx.com/register/shavee/fundID/2 will generate a link like: xxxx.com/register/shavee/23/2014/fundID/2

    const link = window.location.pathname.replace(/\/fundID.*/, '');
    let extra_params;
    const first_occurance = window.location.pathname.indexOf(link);
    if (first_occurance == 0) {
      var string_a_length = link.length;
      extra_params = window.location.pathname.substring(string_a_length);
    } else {
      extra_params = window.location.pathname.substring(0, first_occurance);
      extra_params += window.location.pathname.substring(first_occurance + string_a_length);
    }
    return link + '/' + event.EventID + '/' + event.EventYear + extra_params;
  }

  // main view model for cards in infowindows
  window.EventSearchResults = function EventSearchResults () {
    const self = this;

    self.infoWindows = ko.observable({});
    self.activeInfoWindow = ko.observable({
      infoWindowID: '',
      name: '',
      subname: '',
      subnamehref: '',
      subnameclass: '',
      imagesrc: '',
      actions: [],
      meta: [],
      entitycardclass: ''
    });
    self.searchResults = ko.observableArray([]);
    self.privateJoinURL = ko.observable();

    self.hasResult = function (id, year) {
      let hasIt = false;

      $.each(self.searchResults(), function (index, result) {
        if (result.EventID == id && result.EventYear == year) {
          hasIt = true;
          return false; // breaks the $.each
        }
      });
      return hasIt;
    };

    self.generateCard = function (event) {
      const id = event.EventID;
      const year = event.EventYear;
      var event = sbf.choose_event.get_event(id, year);

      const card = {};
      card.event = event.EventID + '-' + event.EventYear;
      card.infoWindowID = 'event-info';
      card.entitycardclass = 'entity-card';
      card.imagesrc = '/photo/event/' + event.EventID + '/' + event.EventYear;
      card.name = event.EventTitle;

      card.subname = 'View&nbsp;Event&nbsp;Page';
      card.subnamehref = '/events/mypage/' + event.EventID + '/' + event.EventYear;
      card.subnameclass = 'view-event';

      card.isPrivate = parseInt(event.EventAccessTypeID) === 2;

      const metas = [];
      metas.push(new EventMetaData('date', event.EventDate));
      if (event.StartTime != '' || event.EndTime != '') {
        let startTime = '';
        let endTime = '';
        if (event.StartTime != '') {
          startTime = event.StartTime;
        }
        if (event.EndTime != '') {
          endTime = event.EndTime;

          if (startTime == '') {
            startTime = 'TBD';
          }
        }

        const eventTime = startTime + (endTime != '' ? ' &ndash; ' : '') + endTime;
        metas.push(new EventMetaData('time', eventTime));
      }
      if (event.VenueName != '') {
        metas.push(new EventMetaData('venue', event.VenueName));
      }
      if (event.Location != '') {
        metas.push(new EventMetaData('location', event.Location));
      }
      card.meta = ko.observableArray(metas);

      const actions = [];
      if (event.EventAccessTypeID == 2) {
        actions.push(new EventAction('<a class="button info private-event" dataevent="' + String(id) + '-' + String(year) + '" href="#">Join</a>'));
      } else {
        const link = getRearrangedFundIDLink(event);
        actions.push(new EventAction('<a class="button info" href="' + link + '">Join</a>'));
      }

      card.actions = ko.observableArray(actions);

      return card;
    };

    self.joinPrivateEventClick = function (obj) {
      const event = sbf.choose_event.events[$(obj).attr('dataevent')];
      const link = getRearrangedFundIDLink(event);

      self.bindPrivateJoinURL(link);
      sbf.overlay.show('#private-event-check-overlay');
      return false;
    };

    // this makes the hidden info window divs which the google maps infowindow class uses to make content
    self.generateInfoWindows = function (events) {
      let i = 0;
      var ro = new self.repeatingOperation(function (events) {
        try {
          const eventModel = events[getKeys(events)[i]];
          const eventCard = self.generateCard(eventModel);
          self.infoWindows()[getKeys(events)[i]] = eventCard;
          if (++i < getKeys(events).length) {
            ro.step(events);
          } else {
            sbf.choose_event.load_info_windows();
          }
        } catch (e) {
          sbf.choose_event.show_search_error('Sorry, there was an error loading some of our events. ' +
                        'Please refresh the page, and let us know if you keep getting this error.');
        }
      }, 200);

      ro.step(events);
    };

    self.repeatingOperation = function (op, yieldEveryIteration) {
      let count = 0;
      this.step = function (args) {
        if (++count >= yieldEveryIteration) {
          count = 0;
          setTimeout(function () { op(args); }, 20, []);
          return;
        }
        op(args);
      };
    };

    // for resetting search results
    self.resetResults = function () {
      self.searchResults([]);
    };

    self.fadeResultBackground = function (id) {
      $('#search-results li.search-result[dataID=' + id + '] .background').show();
      $('#search-results li.search-result[dataID=' + id + '] .background').fadeOut(2400);
    };

    // for outputting search results
    self.outputResults = function (events) {
      try {
        $('#more-results-div').hide();
        $.each(events, function (index, event) {
          if (index < SEARCH_RESULTS_SIZE) {
            const eventsCard = self.generateCard(event);

            const result = {};
            result.event = String(event.EventID) + '-' + String(event.EventYear);
            result.joinClass = 'button mini info right-join-action';
            if (event.EventAccessTypeID == 2) {
              result.joinClass = result.joinClass + ' private-event';
            }

            const link = getRearrangedFundIDLink(event);

            result.joinURL = link;

            result.isPrivate = parseInt(event.EventAccessTypeID) === 2;

            result.cardDivID = 'event-card-' + event.EventID + '-' + event.EventYear;
            result.cardDiv = eventsCard;

            result.EventID = event.EventID;
            result.EventYear = event.EventYear;

            if (!self.hasResult(event.EventID, event.EventYear)) {
              self.searchResults.push(result);
              self.fadeResultBackground(result.cardDivID);
            }
          } else {
            // there are more results
            $('#more-results-div').show();
            return false;
          }
        });
      } catch (e) {
        self.resetResults();
        sbf.choose_event.show_search_error('Sorry, there was an error loading your search results. Please try again.');
      }
      return self.searchResults();
    };

    self.bindPrivateJoinURL = function (url) {
      self.privateJoinURL(url);
    };
  }

  loadScript();

  // constant for search results size
  var SEARCH_RESULTS_SIZE = 50;
  const $fund_id = $('#fundID').val();

  sbf.choose_event = {
    // variables
    all_events_loaded: false,
    events: {},

    normal_searching: false,
    background_searching: false,

    has_search_results: false,
    saved_search_results: null,
    saved_background_geo_results: null,
    one_box_geocode: null,

    map: null,
    geocoder: null,
    saved_bounds: null,
    saved_point: null,
    open_info_window: null,

    window_size: null,

    saved_search_text: null,
    saved_search_geo: null,
    searches_run: 0,
    // gets an event from the cache by id/year
    get_event: function (id, year) {
      if (sbf.choose_event.events[String(id) + '-' + String(year)] != null) {
        return sbf.choose_event.events[String(id) + '-' + String(year)];
      } else {
        return null;
      }
    },

    // loads the initial map view and saves the map
    load_map: function () {
      if (!isiOS7) {
        const latlng = new google.maps.LatLng(40.79629730, -96.70137310);
        const myOptions = {
          zoom: 4,
          center: latlng,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        sbf.choose_event.map = new google.maps.Map($('#event-map')[0],
          myOptions);

        // if saved zooms and points from event list, execute those
        if (sbf.choose_event.saved_bounds != null) {
          sbf.choose_event.map.fitBounds(sbf.choose_event.saved_bounds);
          sbf.choose_event.saved_bounds = null;
          if (sbf.choose_event.saved_point != null) {
            sbf.choose_event.map.panTo(sbf.choose_event.saved_point);
            sbf.choose_event.saved_point = null;
          }
        } else if (sbf.choose_event.saved_point != null) {
          sbf.choose_event.map.panTo(sbf.choose_event.saved_point);
          sbf.choose_event.saved_point = null;
        } else {
          // zoom to the US
          sbf.choose_event.zoom_rectangle(25, 50, -125, -75);
        }

        // load the markers if they are not yet loaded
        if (sbf.choose_event.all_events_loaded) {
          for (const i in sbf.choose_event.events) {
            const this_event = sbf.choose_event.events[i];
            sbf.choose_event.re_render_marker(this_event.marker);
          }
        }
      }
    },

    // check window size
    check_window_size: function () {
      const width = $(window).width();
      if (width <= 679) {
        sbf.choose_event.window_size = 'small';
      } else if (width <= 979) {
        sbf.choose_event.window_size = 'medium';
      } else {
        sbf.choose_event.window_size = 'large';
      }
      return sbf.choose_event.window_size;
    },

    // flips from event-list to map view in small/medium
    flip_pane: function (newpane) {
      if (sbf.choose_event.check_window_size() != 'large' && !isiOS7) {
        if (newpane == 'eventlist') {
          $('#event-show-list-link').addClass('active');
          $('#event-show-map-link').removeClass('active');
          $('#event-list-container').addClass('active');
          $('#event-map').removeClass('active');
        } else if (newpane == 'eventmap') {
          if (sbf.choose_event.map == null) {
            sbf.choose_event.load_map();
          }
          $('#event-show-map-link').addClass('active');
          $('#event-show-list-link').removeClass('active');
          $('#event-map').addClass('active');
          $('#event-list-container').removeClass('active');
        }
      }
    },

    // denotes searching in the search pane
    indicate_searching: function () {
      $('#search-above').hide();
      $('#event-list').addClass('loading');
      $('#event-list-container').addClass('loading');
      sbf.choose_event.normal_searching = true;
      sbf.choose_event.background_searching = true;

      // clear errors
      sbf.form_errors.close_all_errors();

      // blank search results
      window.viewModel.outputResults([]);
    },

    // reverse of indicate_searching
    indicate_finished_searching: function (flip) {
      if (flip == 'normal') {
        sbf.choose_event.normal_searching = false;
      } else if (flip == 'background') {
        sbf.choose_event.background_searching = false;
      }
      if (!sbf.choose_event.normal_searching && !sbf.choose_event.background_searching) {
        $('#event-list').removeClass('loading');
        $('#event-list-container').removeClass('loading');
      }
    },

    // show a search error in the event list
    show_search_error: function (errorText) {
      window.viewModel.resetResults();
      sbf.form_errors.show_error('event-search', errorText);
      sbf.choose_event.flip_pane('eventlist');
    },

    // bind buttons with private overlay class to show the overlay
    bind_private_overlay_buttons: function () {
      // bind private event join buttons to show overlay instead
      $('a.private-event').on('click', function (click) {
        click.preventDefault();
        window.viewModel.joinPrivateEventClick(this);
        return false;
      });
    },

    /// /// AJAX Calls and callbacks /////

    // ajax call for getting all events on page load
    process_get_all_events: function (success_callback, error_callback) {
      $.ajax({
        dataType: 'json',
        data: {
          fundID: $fund_id
        },
        url: '/register/ajax/getavailableevents',
        type: 'POST',
        success: function (response) {
          if (response.data) {
            sbf.choose_event.events = {};
            for (let i = 0, l = response.data.events.length; i < l; i++) {
              const event = response.data.events[i];
              sbf.choose_event.events[String(event.EventID) + '-' + String(event.EventYear)] = event;
            }
            if (typeof success_callback === 'function') {
              success_callback(response.data);
            }
          } else {
            if (typeof error_callback === 'function') {
              error_callback(response.error);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (typeof error_callback === 'function') {
            error_callback(JSON.parse(jqXHR.responseText));
          }
        }
      });
    },

    // after getting all events, loads the data into info windows and the map
    load_all_events: function () {
      // load data into hidden info window divs
      window.viewModel.generateInfoWindows(sbf.choose_event.events);
    },

    load_info_windows: function () {
      for (const i in sbf.choose_event.events) {
        const event = sbf.choose_event.events[i];
        // load marker on map
        const marker = sbf.choose_event.create_event_marker(event.Latitude, event.Longitude);
        sbf.choose_event.events[i].marker = marker;

        // add listener to make the window appear
        google.maps.event.addListener(marker, 'click', (function (i) {
          return function () {
            // If a window is already opened, close it
            if (sbf.choose_event.open_info_window) {
              sbf.choose_event.open_info_window.close();
            }

            window.viewModel.activeInfoWindow(window.viewModel.infoWindows()[i]);
            const info_window = new InfoBox({
              content: $('#event-info')[0],
              maxWidth: 360,
              boxClass: 'event-info',
              alignBottom: true,
              infoBoxClearance: new google.maps.Size(5, 5),
              pixelOffset: new google.maps.Size(-180, -35),
              closeBoxURL: '/fa/min/php_legacy/icons/x.png'
            });

            info_window.open(sbf.choose_event.map, sbf.choose_event.events[i].marker);
            $('#event-info a.private-event').on('click', function () {
              window.viewModel.joinPrivateEventClick(this);
              return false;
            });

            $('#event-info a.private-event').closest('#event-info').find('.private-event-label').each(function () {
              var $this = $(this);
              $('<br/>').insertAfter(
                $this.html('PRIVATE')
                  .css('display', 'inline-block')
                  .next('span.private-event-tooltip-button')
                  .css('display', 'inline-block')
              );
              privateEventTooltipButtonAssignEventHandlers($this.next('span.private-event-tooltip-button'));
            });

            sbf.choose_event.open_info_window = info_window;
            sbf.choose_event.pan_to_point(sbf.choose_event.events[i].marker.getPosition().lat(), sbf.choose_event.events[i].marker.getPosition().lng());
          };
        }(i)));
      }

      sbf.choose_event.all_events_loaded = true;
      sbf.choose_event.load_search_results();
      sbf.choose_event.bind_private_overlay_buttons();
    },

    // ajax-like call for geolocating
    process_geolocate: function () {
      if (navigator.geolocation) {
        try {
          navigator.geolocation.getCurrentPosition(
            sbf.choose_event.geolocate_success,
            sbf.choose_event.geolocate_error,
            { timeout: 10000 }
          );
        } catch (e) {
          sbf.choose_event.geolocate_error();
        }
      } else {
        // Geolocation not supported by browser, don't do anything
      }
    },

    geolocate_success: function (position) {
      // reset things
      sbf.choose_event.searches_run = 0;
      sbf.choose_event.saved_search_text = null;
      sbf.choose_event.saved_search_geo = null;
      window.viewModel.resetResults();

      // run a geolocate search on that location
      sbf.choose_event.process_geolocation_search(position.coords.latitude, position.coords.longitude,
        sbf.choose_event.load_search_results,
        function () {
          sbf.choose_event.show_search_error('Sorry, there was an error loading your search results. Please try again.');
        }
      );
    },

    geolocate_error: function (positionError) {
      // get error type and display error message
      // positionError.code = 1 => permission denied
      // positionError.code = 2 => unavailable
      // positionError.code = 3 => timeout
      if (!positionError || positionError.code == 2) {
        sbf.form_errors.show_error('geolocate', 'We were unable to find your location. Please search for your event above.');
      } else if (positionError.code == 3) {
        sbf.form_errors.show_error('geolocate', 'Your browser timed out while trying to find your location. Please refresh the page and try again, or search for your event above.');
      }
    },

    // ajax call for running a geolocation search -- called AFTER browser geolocate is allowed
    process_geolocation_search: function (latitude, longitude, success_callback, error_callback) {
      $('#finding-location-alert').fadeIn(200);
      // clear errors
      sbf.form_errors.close_all_errors();
      sbf.choose_event.one_box_geocode = null;

      $('#search-above').hide();
      $.ajax({
        dataType: 'json',
        url: '/register/ajax/eventsearch',
        type: 'POST',
        data: {
          latitude,
          longitude,
          searchType: 'geolocation',
          maxResults: SEARCH_RESULTS_SIZE + 1,
          offset: SEARCH_RESULTS_SIZE * sbf.choose_event.searches_run
        },
        success: function (response) {
          if (response.data) {
            sbf.choose_event.saved_search_geo = { lat: latitude, lon: longitude };
            sbf.choose_event.saved_search_text = null;
            sbf.choose_event.searches_run += 1;
            sbf.choose_event.has_search_results = true;
            sbf.choose_event.saved_search_results = response.data;

            if (typeof success_callback === 'function') {
              success_callback(response.data);
            }
          } else {
            if (typeof error_callback === 'function') {
              error_callback(response.error);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (typeof error_callback === 'function') {
            error_callback(JSON.parse(jqXHR.responseText));
          }
        },
        complete: function () {
          $('#finding-location-alert').hide();
        }
      });
    },

    // ajax call for a background geolocation on onebox search
    process_one_box_background_geolocation_search: function (latitude, longitude, success_callback, error_callback) {
      sbf.choose_event.saved_background_geo_results = null;

      $.ajax({
        dataType: 'json',
        url: '/register/ajax/eventsearch',
        type: 'POST',
        data: {
          latitude,
          longitude,
          searchType: 'geolocation',
          maxResults: SEARCH_RESULTS_SIZE,
          offset: 0
        },
        success: function (response) {
          if (response.data) {
            sbf.choose_event.saved_background_geo_results = response.data;

            if (typeof success_callback === 'function') {
              success_callback(response.data);
            }
          } else {
            if (typeof error_callback === 'function') {
              error_callback(response.error);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (typeof error_callback === 'function') {
            error_callback(JSON.parse(jqXHR.responseText));
          }
        }
      });
    },

    // ajax call for searching events from the box
    process_one_box_search: function (searchText, success_callback, error_callback) {
      sbf.choose_event.one_box_geocode = null;
      sbf.choose_event.indicate_searching();
      $('#search-above').hide();

      // run the async geocoder
      sbf.choose_event.geocoder.geocode({ address: searchText }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          sbf.choose_event.one_box_geocode = results[0].geometry.location;
          sbf.choose_event.process_one_box_background_geolocation_search(sbf.choose_event.one_box_geocode.lat(), sbf.choose_event.one_box_geocode.lng(),
            function (data) {
              if (data.events != null) {
                sbf.choose_event.show_want_more_results();
              }
            },
            function () {
              sbf.choose_event.indicate_finished_searching('background');
            }
          );
        } else {
          sbf.choose_event.indicate_finished_searching('background');
        }
      });

      $.ajax({
        dataType: 'json',
        url: '/register/ajax/eventsearch',
        type: 'POST',
        data: {
          searchText,
          searchType: 'onebox',
          maxResults: SEARCH_RESULTS_SIZE + 1,
          offset: SEARCH_RESULTS_SIZE * sbf.choose_event.searches_run
        },
        success: function (response) {
          sbf.choose_event.saved_search_geo = null;
          sbf.choose_event.saved_search_text = searchText;
          sbf.choose_event.searches_run += 1;
          sbf.choose_event.has_search_results = true;
          if (response.data) {
            sbf.choose_event.saved_search_results = response.data;
            if (typeof success_callback === 'function') {
              success_callback(response.data);
            }
          } else {
            if (typeof error_callback === 'function') {
              error_callback(response.error);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (typeof error_callback === 'function') {
            error_callback(JSON.parse(jqXHR.responseText));
          }
        },
        complete: function () {
          sbf.choose_event.indicate_finished_searching('normal');
        }
      });
    },

    show_want_more_results: function () {
      if (sbf.choose_event.saved_background_geo_results != null && sbf.choose_event.saved_background_geo_results.events != [] && sbf.choose_event.has_search_results) {
        let count = 0;
        $.each(sbf.choose_event.saved_background_geo_results.events, function (index, this_event) {
          if (!window.viewModel.hasResult(this_event.EventID, this_event.EventYear) && sbf.choose_event.get_event(this_event.EventID, this_event.EventYear) != null) {
            count += 1;
          }
        });
        if (count > 0 && !$('#more-results-div').is(':visible')) {
          $('#number-of-events-nearby').html(count + (window.viewModel.searchResults().length != 0 ? ' more' : '') + ' event' + (count != 1 ? 's' : ''));
          $('#events-nearby-error').show();
        }
      }
      sbf.choose_event.indicate_finished_searching('background');
    },

    // after running a search, loads the results in the search window
    load_search_results: function (data) {
      if (sbf.choose_event.all_events_loaded && sbf.choose_event.has_search_results) {
        if (data == null || data == undefined) {
          data = sbf.choose_event.saved_search_results;
        }
        if (data.events.length == 0) {
          sbf.form_errors.show_error('no-events', 'Sorry, we didn’t find any results. If you’re having trouble finding an event, call us at <a href="tel:8888992253">(888)&nbsp;899&#8209;2253</a>.<br><br><a href="/be-a-virtual-shavee">Want to shave on your own?</a>');
          sbf.choose_event.flip_pane('eventlist');
        }

        const saved_found_events = [];

        for (var i in data.events) {
          if (sbf.choose_event.get_event(data.events[i].EventID, data.events[i].EventYear) != null) {
            saved_found_events.push(sbf.choose_event.get_event(data.events[i].EventID, data.events[i].EventYear));
          }
        }

        // Possible that events came back from search service that were not in the initial list of events (roles closed is an example).
        // Therefore we need to show the 'not found' message if we failed to actually get events from the local cache based on the ids
        // that came back from the search service
        if (saved_found_events.length == 0) {
          sbf.form_errors.show_error('no-events', 'Sorry, we didn’t find any results. If you’re having trouble finding an event, call us at <a href="tel:8888992253">(888)&nbsp;899&#8209;2253</a>.<br><br><a href="/be-a-virtual-shavee">Want to shave on your own?</a>');
          sbf.choose_event.flip_pane('eventlist');
        }
        // results pane
        const searchResults = window.viewModel.outputResults(saved_found_events);

        // change markers
        for (var i in sbf.choose_event.events) {
          try {
            var event = sbf.choose_event.events[i];
            event.marker.setIcon('https://maps.google.com/mapfiles/marker.png');
          } catch (e) {
            continue;
          }
        }
        for (var i in searchResults) {
          try {
            var event = sbf.choose_event.get_event(searchResults[i].EventID, searchResults[i].EventYear);
            event.marker.setIcon('/fa/min/php_legacy/register/map-marker.png');
          } catch (e) {
            continue;
          }
        }

        if (searchResults.length > 0) {
          // zoom to an appropriate place
          let maxLat = -90;
          let minLat = 90;
          let minLon = 180;
          let maxLon = -180;

          if (sbf.choose_event.saved_search_geo != null) {
            maxLat = parseFloat(sbf.choose_event.saved_search_geo.lat);
            minLat = parseFloat(sbf.choose_event.saved_search_geo.lat);
            maxLon = parseFloat(sbf.choose_event.saved_search_geo.lon);
            minLon = parseFloat(sbf.choose_event.saved_search_geo.lon);
          }

          for (var i in searchResults) {
            var event = sbf.choose_event.get_event(searchResults[i].EventID, searchResults[i].EventYear);

            if (parseFloat(event.Latitude) > maxLat) {
              maxLat = parseFloat(event.Latitude);
            }
            if (parseFloat(event.Latitude) < minLat) {
              minLat = parseFloat(event.Latitude);
            }

            if (parseFloat(event.Longitude) > maxLon) {
              maxLon = parseFloat(event.Longitude);
            }
            if (parseFloat(event.Longitude) < minLon) {
              minLon = parseFloat(event.Longitude);
            }
          }

          if (!(maxLat == -90 && minLat == 90 && minLon == 180 && maxLon == -180)) {
            if (minLat == maxLat) {
              // add .1 degree width
              minLat -= 0.1;
              maxLat += 0.1;
            } else {
              // add 10% width
              minLat -= 0.1 * (maxLat - minLat);
              maxLat += 0.1 * (maxLat - minLat);
            }
            if (minLon == minLon) {
              // add .1 degree width
              minLon -= 0.1;
              maxLon += 0.1;
            } else {
              // add 10% width
              minLon -= 0.1 * (maxLon - minLon);
              maxLon += 0.1 * (maxLon - minLon);
            }

            sbf.choose_event.zoom_rectangle(minLat, maxLat, minLon, maxLon);
          }

          sbf.choose_event.bind_private_overlay_buttons();

          privateEventHandleIndicators();
          privateEventToolTipButtonsAssignEventHandlers();
        }
      }
    },

    /// // MAP functions //////

    // drops an event marker at the given location and returns it
    create_event_marker: function (latitude, longitude) {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: sbf.choose_event.map,
        optimized: false,
        visible: true
      });

      return marker;
    },

    re_render_marker: function (marker) {
      marker.setMap(sbf.choose_event.map);
    },

    // pans the map to a certain location
    pan_to_point: function (lat, lon) {
      if (sbf.choose_event.check_window_size() == 'large') {
        // step 1: find out what the full map size looks like and where the 'map viewport' is
        const mapWidth = $('#event-map').width();
        const mapHeight = $('#event-map').height();
        const listWidth = $('#event-list').width();
        const listPosition = 90;

        const portWidth = mapWidth - listWidth - listPosition;
        const portHeight = mapHeight;
        const portX = mapWidth - portWidth;
        const portY = 0;

        // step 2: get the bounds of the map currently so we can scale the pixels to the zoom
        const bounds = sbf.choose_event.map.getBounds();

        const minLat = bounds.getSouthWest().lat();
        const minLon = bounds.getSouthWest().lng();

        const maxLat = bounds.getNorthEast().lat();
        const maxLon = bounds.getNorthEast().lng();

        const pixelsPerDeg = mapWidth / (maxLat - minLat);

        // how far over should we move the center?
        const portCenterX = (portWidth / 2) + portX;
        const portXDiff = portCenterX - (mapWidth / 2);
        lon = lon - (portXDiff / pixelsPerDeg);
      }

      const point = new google.maps.LatLng(lat, lon);

      if (sbf.choose_event.map != null) {
        sbf.choose_event.map.panTo(point);
      } else {
        sbf.choose_event.saved_point = point;
      }
    },

    // zooms the map to a certain area
    zoom_rectangle: function (minLat, maxLat, minLon, maxLon) {
      if (sbf.choose_event.check_window_size() == 'large') {
        // step 1: find out what the full map size looks like and where the 'map viewport' is
        const mapWidth = $('#event-map').width();
        const mapHeight = $('#event-map').height();
        const listWidth = $('#event-list').width();
        const listPosition = 90;

        const portWidth = mapWidth - listWidth - listPosition;
        const portHeight = mapHeight;
        const portX = mapWidth - portWidth;
        const portY = 0;

        // is the ratio of the bounds the same orientation as the map viewport?
        const portRatio = portWidth / portHeight;
        const boundsRatio = (maxLon - minLon) / (maxLat - minLat);

        const pixelBuffer = 100; // we need this because if you try to google.maps.map.fitBounds on an exact fit it can zoom out

        if (portRatio <= boundsRatio) {
          // first proportionalize bounds to portWidth
          var pixelsPerDeg = (portWidth) / (maxLon - minLon);
          const boundsHeightPixels = pixelsPerDeg * (maxLat - minLat);
          const vertPaddingPixels = ((portHeight - boundsHeightPixels) / 2) - pixelBuffer;
          minLat = minLat - (vertPaddingPixels / pixelsPerDeg);
          maxLat = maxLat + (vertPaddingPixels / pixelsPerDeg);

          // the bounds should now match the proportion of the map viewport
          // just need to add the padding outside the map viewport now

          // add degrees on left
          minLon = minLon - ((portX - pixelBuffer) / pixelsPerDeg);
        } else if (portRatio > boundsRatio) {
          // first proportionalize bounds to portHeight
          var pixelsPerDeg = (portHeight) / (maxLat - minLat);
          const boundsWidthPixels = pixelsPerDeg * (maxLon - minLon);
          const horizPaddingPixels = ((portWidth - boundsWidthPixels) / 2) - pixelBuffer;
          minLon = minLon - (horizPaddingPixels / pixelsPerDeg);
          maxLon = maxLon + (horizPaddingPixels / pixelsPerDeg);

          // the width bounds should now be proportionate to the viewport
          // just need to add the padding outside the map viewport now

          // add degrees on left -- pixel buffer already added
          minLon = minLon - ((portX) / pixelsPerDeg);
        }
      }

      const sw = new google.maps.LatLng(minLat, minLon);
      const ne = new google.maps.LatLng(maxLat, maxLon);
      const bounds = new google.maps.LatLngBounds(sw, ne);

      if (sbf.choose_event.map != null) {
        sbf.choose_event.map.fitBounds(bounds);
      } else {
        sbf.choose_event.saved_bounds = bounds;
      }
    }
  };
  //$(initMap);
});

/**
 * Workaround for showing the private event label and tooltip.
 *
 * @return    none
 */
const privateEventHandleIndicators = () => {
  $('#search-results > li .private-event-label').each(function () {
    const $this = $(this);
    if ($this.html() === 'true') {
      $this.html('PRIVATE').css('display', 'inline-block').next('span.private-event-tooltip-button').css('display', 'inline-block');
    }
  });
};

/**
 * Assign event handlers for private event tooltip buttons.
 *
 * @return    none
 */
const privateEventToolTipButtonsAssignEventHandlers = () => {
  $('#search-results > li .private-event-tooltip-button').each(function () {
    privateEventTooltipButtonAssignEventHandlers($(this));
  });
};

/**
 * Assign event handlers for private event tooltip button.
 *
 * @param     object    $button    A jquery wrapped HTML element.
 * @return    none
 */
const privateEventTooltipButtonAssignEventHandlers = ($button) => {
  // Button - mouse enter event.
  $button.unbind('mouseenter').bind('mouseenter', function () {
    const $this  = $(this);
    const $popup = $('.private-event-tooltip-popoup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth   = $popup.width();
      const popupHeight  = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        'display': 'block',
        'top': buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        'left': buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $button.unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popoup').css('display', 'none');
  });
};

function loadScript() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://maps.google.com/maps/api/js?key=' + googleAPIKey + '&libraries=places&callback=initMap';

  script.onload = () => {
    // Once the Google Maps script has loaded, dynamically import the InfoBox module
    import('../lib/google_maps_infobox')
    .then(module => {
      window.InfoBox = module.default;
    }).catch(error => {
      console.error('Error loading InfoBox module:', error);
    });
  };
  document.body.appendChild(script);
}
